/* Add to Cart buttons (.mb-atc[name="add"] and the sticky bar button): keeps the spinner going for at least
   two full turns once Shopify's add-to-cart request starts, then plays the
   "Added" sequence (check draws, slides left, "Added" fades in) before
   resetting. It only watches the button's own `loading` class / aria-busy, so
   product-form.js is untouched. The CSS for each state is in base.css. */
(function () {
	const TURN = 700; // one spinner turn (matches the CSS .7s)
	const MIN_TURNS = 2; // spin at least 2 rounds
	const HOLD = 800; // how long "Added" stays before resetting
	const SEQUENCE = 1150; // check draw + slide + text fade-in

	function statusHtml(label) {
		return (
			'<span class="mb-atc__status" aria-hidden="true">' +
			'<svg class="mb-atc__check" viewBox="0 0 24 24" fill="none">' +
			'<path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>' +
			'</svg>' +
			'<span class="mb-atc__added">' + label + '</span>' +
			'</span>'
		);
	}

	// Copy the label's computed type onto the "Added" status so it matches the
	// button's own font (each button styles its label differently).
	function syncFont(btn) {
		const label = btn.querySelector('.mb-atc__label');
		const status = btn.querySelector('.mb-atc__status');
		if (!label || !status) return;
		const cs = window.getComputedStyle(label);
		const props = [
			['font-family', cs.fontFamily],
			['font-size', cs.fontSize],
			['font-weight', cs.fontWeight],
			['font-style', cs.fontStyle],
			['line-height', cs.lineHeight],
			['letter-spacing', cs.letterSpacing],
			['text-transform', cs.textTransform],
		];
		// Set on the status and on the "Added" text itself, as important, so no
		// per-button span rule (cards, featured product, sticky bar) can override it.
		const added = status.querySelector('.mb-atc__added');
		props.forEach(([name, value]) => {
			status.style.setProperty(name, value, 'important');
			if (added) added.style.setProperty(name, value, 'important');
		});
		// Keep the clipped box tall enough for the glyphs whatever the button's line height.
		if (added) added.style.setProperty('line-height', '1.6', 'important');
	}

	function enhance(btn) {
		if (btn.dataset.mbAtc) return;
		btn.dataset.mbAtc = '1';

		const strings = window.variantStrings || {};
		const addedLabel = btn.dataset.addedLabel || strings.added || 'Added';
		if (!btn.querySelector('.mb-atc__status')) {
			btn.insertAdjacentHTML('beforeend', statusHtml(addedLabel));
		}

		// Screen-reader announcement for the added state.
		const live = document.createElement('span');
		live.className = 'mb-atc__sr';
		live.setAttribute('role', 'status');
		btn.insertAdjacentElement('afterend', live);

		let start = 0;
		let timer = null;
		let wasBusy = false;
		let errored = false;

		// The sticky bar has no <product-form> ancestor to read an error from, so it
		// relies on cart:error. Only count one that arrives during this button's own
		// request, and stop listening once the button has been re-rendered away.
		const onCartError = () => {
			if (!btn.isConnected) {
				document.removeEventListener('cart:error', onCartError);
				return;
			}
			if (btn.classList.contains('is-loading') || btn.classList.contains('loading')) errored = true;
		};
		document.addEventListener('cart:error', onCartError);

		const isBusy = () =>
			btn.classList.contains('loading') || btn.getAttribute('aria-busy') === 'true';

		new MutationObserver(() => {
			const busy = isBusy();
			if (busy && !wasBusy) {
				// request started
				clearTimeout(timer);
				btn.classList.remove('is-added');
				btn.classList.add('is-loading');
				live.textContent = '';
				errored = false;
				start = performance.now();
			} else if (!busy && wasBusy) {
				// request finished
				const scope = btn.closest('product-form');
				const failed =
					errored ||
					(scope && scope.querySelector('.product-form__error-message-wrapper:not([hidden])'));
				const elapsed = performance.now() - start;
				// Finish on a full turn, and never before 2 turns.
				const target = Math.max(TURN * MIN_TURNS, Math.ceil(elapsed / TURN) * TURN);
				timer = setTimeout(() => {
					btn.classList.remove('is-loading');
					if (failed) return; // error: back to default
					syncFont(btn);
					btn.classList.add('is-added');
					live.textContent = btn.dataset.addedAnnounce || (window.variantStrings && window.variantStrings.addedToCart) || 'Added to cart';
					timer = setTimeout(() => btn.classList.remove('is-added'), SEQUENCE + HOLD);
				}, target - elapsed);
			}
			wasBusy = busy;
		}).observe(btn, { attributes: true, attributeFilter: ['class', 'aria-busy'] });
	}

	function init() {
		document.querySelectorAll('.mb-atc[name="add"], .sticky-atc__submit.mb-atc, .mb-atc[data-configurator-add]').forEach((btn) => {
			// Only real add-to-cart buttons: quick view buttons share name="add" but
			// just open a modal, so they get the spinner (CSS) and never "Added".
			if (btn.closest('product-form') || btn.matches('.sticky-atc__submit, [data-configurator-add]')) enhance(btn);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	// The product form can be re-rendered (variant change, section reload), which
	// replaces the button; pick up any new one.
	let queued = false;
	new MutationObserver(() => {
		if (queued) return;
		queued = true;
		requestAnimationFrame(() => {
			queued = false;
			init();
		});
	}).observe(document.documentElement, { childList: true, subtree: true });
})();
